<template>
  <v-card class="card">
    <v-card-title class="justify-start">
      <span class="font-weight-bold"
        >{{ this.title }}Pemesanan Barang ke Supplier
      </span>
      <v-btn absolute right icon @click="onCloseButtonClick()">
        <v-icon> mdi-close </v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <div style="margin-top: 20px;">
        <span class="sub-header">Data Supplier</span>
      </div>
      <div :class="['detail-panel', { cancelled: isCancelledDetail }]">
        <div>
          <v-form lazy-validation ref="formSupplier" class="detail-container">
            <div class="input-container">
              <span>Nomor Pemesanan</span>
              <div>{{ newReceiptNumber }}</div>
            </div>
            <div class="input-container">
              <span>Nama Supplier</span>
              <div style="flex: 1;">
                <v-autocomplete
                  dense
                  outlined
                  :rules="rules.required"
                  item-text="name"
                  item-value="id"
                  hide-details="auto"
                  :items="selectSupplier"
                  v-model="form.supplier"
                  return-object
                  append-icon="mdi-chevron-down"
                  placeholder="Pilih Supplier"
                  :disabled="isDisabled"
                  @change="hasChanges = true"
                ></v-autocomplete>
              </div>
            </div>
            <div class="input-container">
              <span>Metode Pembayaran</span>
              <div style="flex: 1;">
                <v-select
                  :disabled="isDisabled"
                  hide-details="auto"
                  dense
                  placeholder="Pilih Metode Pembayaran"
                  single-line
                  :rules="rules.required"
                  :items="resource.paymentMethod"
                  v-model="form.payment_method"
                  outlined
                  @change="hasChanges = true"
                  append-icon="mdi-chevron-down"
                />
              </div>
            </div>
            <div class="input-container" v-if="this.isDetail">
              <span>Status</span>
              <div :class="['badge', form.status]">
                {{
                  form.status === 'received'
                    ? 'Sudah Diterima'
                    : form.status === 'cancelled'
                    ? 'Dibatalkan'
                    : 'Belum Diterima'
                }}
              </div>
            </div>
          </v-form>
        </div>

        <div
          class="detail-container"
          style="border-left: 1px solid #E0E0E0; padding-left: 40px;"
        >
          <div class="input-container">
            <span>Tanggal Pemesanan</span>
            <div>{{ form.orderDate }}</div>
          </div>
          <div class="input-container">
            <span>Petugas Order</span>
            <div>{{ isDetail ? form.orderStaff : activeUser.name }}</div>
          </div>
        </div>
        <div
          class="detail-container"
          style="border-left: 1px solid #E0E0E0; padding-left: 40px;"
          v-if="isCancelledDetail"
        >
          <div class="input-container">
            <span>Tanggal Pembatalan</span>
            <div>{{ form.orderDate }}</div>
          </div>
          <div class="input-container">
            <span>Petugas Pembatalan</span>
            <div>{{ activeUser.name }}</div>
          </div>
        </div>
      </div>

      <div :class="['form-container', { active: !isDisabled }]">
        <div class="sub-header" v-if="!isDisabled">Form Input Barang</div>
        <v-form
          lazy-validation
          class="form-input"
          ref="form"
          v-if="!isDisabled"
        >
          <div>
            <label>Nama Barang <span>*</span></label>
            <v-autocomplete
              dense
              outlined
              clearable
              :rules="rules.required"
              item-text="displayName"
              item-value="id"
              :items="selectBarang"
              return-object
              v-model="formDetail.goods"
              background-color="white"
              append-icon="mdi-chevron-down"
              placeholder="Pilih Barang"
              @change="getPackage()"
              :disabled="isDisabled"
              :search-input.sync="searchGood"
              disable-item="disabled"
            ></v-autocomplete>
          </div>
          <div>
            <label>Jumlah Pesanan <span>*</span></label>
            <v-currency-field
              :rules="rules.notZero"
              dense
              placeholder="Masukkan Jumlah Pesanan"
              v-model="formDetail.quantity"
              :decimal-length="0"
              outlined
              background-color="white"
              :disabled="isDisabled"
            ></v-currency-field>
          </div>
          <div>
            <label>Package <span>*</span></label>
            <v-autocomplete
              dense
              outlined
              :rules="rules.required"
              item-text="name"
              :items="packageItem"
              v-model="formDetail.package"
              return-object
              clearable
              background-color="white"
              append-icon="mdi-chevron-down"
              placeholder="Pilih Package"
              :disabled="isDisabled"
            ></v-autocomplete>
          </div>
          <div>
            <label>Harga</label>
            <v-currency-field
              class="currency label"
              background-color="#F5F5F5"
              placeholder="0"
              solo
              dense
              flat
              outlined
              :value="
                calculatePrice(
                  formDetail.goods?.hna,
                  formDetail.package?.quantity,
                )
              "
              disabled
              single-line
              prefix="Rp"
            ></v-currency-field>
          </div>
        </v-form>
        <div
          style="display: flex; justify-content: end; margin-top: 20px;"
          v-if="!isDisabled"
        >
          <v-btn outlined color="primary" @click="addNewList"
            >Tambahkan ke Tabel<v-icon small>mdi-plus</v-icon></v-btn
          >
        </div>

        <div class="h-separator" v-if="!isDisabled"></div>
        <div class="form-table">
          <div class="sub-header" v-if="!isDisabled">
            Daftar Barang yang Dipesan
          </div>
          <v-form lazy-validation ref="formTable">
            <v-data-table
              class="flex-grow-1 mt-4 sticky-table"
              :headers="table.headers"
              :items="form.item"
              hide-default-footer
              :items-per-page="-1"
              item-key="index"
            >
              <template v-slot:item="{ item, index }">
                <tr class="" style="padding-top: 10px;" :key="index">
                  <td class="text-sm-left">{{ index + 1 }}</td>
                  <td
                    class="text-sm-left"
                    style="padding-top: 10px; padding-bottom:10px"
                  >
                    <span v-if="isDisabled">{{ item.goods?.name }} </span>
                    <v-autocomplete
                      v-else
                      dense
                      outlined
                      clearable
                      :rules="rules.required"
                      item-text="displayName"
                      item-value="id"
                      :items="item.listItemGoods"
                      return-object
                      hide-details="auto"
                      v-model="item.goods"
                      background-color="white"
                      append-icon="mdi-chevron-down"
                      placeholder="Pilih Barang"
                      @change="
                        getPackage(true, index);
                        hasChanges = true;
                      "
                      :disabled="isDisabled"
                      disable-item="disabled"
                      @update:search-input="
                        onSearchGoodsInItemList($event, index)
                      "
                    ></v-autocomplete>
                  </td>
                  <td
                    class="text-sm-left"
                    style="padding-top: 10px; padding-bottom:10px"
                  >
                    <span v-if="isDisabled">{{ item.quantity }}</span>
                    <v-currency-field
                      v-else
                      :rules="rules.required"
                      dense
                      placeholder="Masukkan Jumlah Pesanan"
                      v-model="item.quantity"
                      :decimal-length="0"
                      outlined
                      hide-details="auto"
                      background-color="white"
                      :disabled="isDisabled"
                      @input="hasChanges = true"
                    ></v-currency-field>
                  </td>
                  <td
                    class="text-sm-left"
                    style="padding-top: 10px; padding-bottom:10px"
                  >
                    <span v-if="isDisabled">{{ item.package?.name }}</span>
                    <v-autocomplete
                      v-else
                      dense
                      outlined
                      :rules="rules.required"
                      item-text="name"
                      item-value="name"
                      :items="item.packageItem"
                      v-model="item.package"
                      return-object
                      clearable
                      hide-details="auto"
                      background-color="white"
                      append-icon="mdi-chevron-down"
                      placeholder="Pilih Package"
                      :disabled="isDisabled"
                      @change="hasChanges = true"
                    ></v-autocomplete>
                  </td>
                  <td class="text-sm-right">
                    {{
                      formatCurrency(
                        item.package?.quantity
                          ? calculatePrice(
                              item.goods?.hna,
                              item.package?.quantity,
                            )
                          : item.price || 0,
                      )
                    }}
                  </td>
                  <td class="text-sm-right">
                    {{
                      formatCurrency(
                        item.quantity *
                          (item.package?.quantity
                            ? calculatePrice(
                                item.goods?.hna,
                                item.package?.quantity,
                              )
                            : item.price || 0),
                      )
                    }}
                  </td>
                  <td class="text-sm-left">
                    <v-btn
                      v-if="!isDisabled"
                      icon
                      :disabled="subItemLoad"
                      text
                      @click="removeFromList(index)"
                      ><v-icon small>mdi-delete</v-icon></v-btn
                    >
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-form>
        </div>
        <div style="display: flex; align-items: center; justify-content: end;">
          <v-form lazy-validation ref="formCost" class="cost-details">
            <div class="item-detail">
              <label>Total</label>
              <div>{{ formatCurrency(totalAllItemPrice) }}</div>
            </div>
            <div class="item-detail">
              <label>PPN</label>
              <div
                style="display: flex; align-items: start; justify-content: space-between; gap: 20px;"
              >
                <v-currency-field
                  dense
                  placeholder="PPN"
                  v-model="form.ppn"
                  :decimal-length="0"
                  outlined
                  hide-details="auto"
                  class="currency"
                  suffix="%"
                  background-color="white"
                  :disabled="isDisabled"
                  @input="hasChanges = true"
                ></v-currency-field>
                <div style="margin-top: 10px;">
                  {{ formatCurrency(totalPpn) }}
                </div>
              </div>
            </div>
            <div class="h-separator" style="margin: 0px;"></div>
            <span>Biaya Tambahan</span>
            <div class="item-detail">
              <label>Biaya Materai</label>
              <v-currency-field
                dense
                class="currency"
                placeholder="Masukkan Saldo"
                v-model="form.stamp_cost"
                :decimal-length="0"
                outlined
                :disabled="isDisabled"
                hide-details="auto"
                prefix="Rp"
                background-color="white"
                @input="hasChanges = true"
              ></v-currency-field>
            </div>
            <div class="item-detail">
              <label>Biaya Ongkir</label>
              <v-currency-field
                prefix="Rp"
                dense
                placeholder="Masukkan Saldo"
                v-model="form.shipping_cost"
                :decimal-length="0"
                :disabled="isDisabled"
                hide-details="auto"
                outlined
                class="currency"
                background-color="white"
                @input="hasChanges = true"
              ></v-currency-field>
            </div>
            <div class="h-separator" style="margin: 0px;"></div>
            <span>Tagihan</span>
            <div
              style="background-color: #EDEDED; padding: 12px; border-radius: 4px;"
            >
              <div class="item-detail">
                <label>Total Tagihan</label>
                <div>{{ formatCurrency(totalBill) }}</div>
              </div>
            </div>

            <div class="item-detail">
              <label>Uang Muka Pemesanan</label>
              <div
                style="display: flex; align-items: start; justify-content: space-between; gap: 10px;"
              >
                <v-btn
                  @click="switchDpType()"
                  :disabled="isDisabled"
                  color="grey"
                  icon
                  text
                  ><v-icon>mdi-swap-vertical</v-icon></v-btn
                >

                <v-currency-field
                  dense
                  placeholder="Masukkan Saldo"
                  v-model="form.down_payment"
                  :disabled="isDisabled"
                  :rules="rules.downPayment"
                  class="currency"
                  :decimal-length="0"
                  hide-details="auto"
                  outlined
                  :prefix="form.isDpTypePercent ? '' : 'Rp'"
                  :suffix="form.isDpTypePercent ? '%' : ''"
                  background-color="white"
                  @input="hasChanges = true"
                ></v-currency-field>
              </div>
            </div>
            <div class="item-detail">
              <label>Sisa Tagihan</label>
              <div>{{ formatCurrency(outstandingBill) }}</div>
            </div>
          </v-form>
        </div>
      </div>
    </v-card-text>
    <div
      v-if="!isCancelledDetail"
      style="position: fixed; bottom: 0; width: 100%; background: white; padding-top: 15px; padding-bottom: 15px;"
    >
      <div
        style="display: flex; justify-content: flex-end; padding-right: 25px;"
      >
        <v-btn
          :disabled="form.item.length <= 0"
          v-if="!isDetail"
          color="primary"
          @click="saveDataOrder"
          >Simpan</v-btn
        >
        <div
          @click="onClickCancelOrder"
          v-if="
            isDetail && form.status === 'pending' && isDisabled && isDataCreator
          "
          style="cursor: pointer; color: red; margin-right: auto; margin-left: 30px; display: flex; align-items: center; gap: 10px;"
        >
          <v-icon medium style="color: red;">mdi-close</v-icon> Batalkan
          Pemesanan
        </div>
        <v-btn
          v-if="isDetail && form.status === 'pending' && isDataCreator"
          outlined
          color="primary"
          style="margin-right: 10px;"
          @click="onCancelChanges"
        >
          <div style="display: flex; align-items: center; gap: 10px;">
            <v-icon small v-if="!isEditMode">mdi-pencil</v-icon
            >{{ isEditMode ? 'Batalkan' : 'Ubah' }}
          </div></v-btn
        >
        <v-btn
          v-if="isDetail && !isEditMode"
          outlined
          color="primary"
          :disabled="!form.supplier || form.supplier === ''"
          style="margin-right: 10px;"
          @click="printSp()"
          :loading="isPrintLoading"
        >
          <div style="display: flex; align-items: center; gap: 10px;">
            <v-icon small>mdi-printer</v-icon>Cetak Surat Pemesanan
          </div></v-btn
        >
        <v-btn
          v-if="!isEditMode && form.status === 'pending'"
          color="primary"
          :disabled="!form.supplier || form.supplier === ''"
          @click="confirmOrSaveChanges(!isEditMode)"
        >
          <div style="display: flex; align-items: center; gap: 10px;">
            <v-icon small>mdi-shopping-outline</v-icon>
            {{ 'Konfirmasi Penerimaan' }}
          </div></v-btn
        >

        <v-btn
          v-if="isEditMode"
          color="primary"
          :disabled="!hasChanges || this.form.item.length <= 0"
          @click="confirmOrSaveChanges()"
        >
          <div style="display: flex; align-items: center; gap: 10px;">
            Simpan Perubahan
          </div></v-btn
        >
      </div>
    </div>
    <v-snackbar :color="snackbar.color" timeout="4000" v-model="snackbar.show">
      {{ snackbar.text }}
      <v-btn
        text
        fab
        dense
        depressed
        small
        class="ml-10"
        @click.native="snackbar.show = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-dialog v-model="dialog" max-width="1200px" persistent fullscreen>
      <InputItemReceipt
        :isFromInputItem="true"
        v-if="dialog"
        :isConfirmation="true"
        :spnumber="newReceiptNumber"
        :supplierName="form.supplier.name"
        @close-form="closeForm"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import Constant from '@/const';
const moment = require('moment-timezone');
import PrintMixin from '@/mixin/printMixin';
import PrintItemOrder from '@/mixin/printItemOrder';
import Swal from 'sweetalert2';
const axios = require('axios');
const _ = require('lodash');
import InputItemReceipt from '../ItemReceiptComponent/InputItemReceipt.vue';

export default {
  mixins: [PrintMixin, PrintItemOrder],
  components: {
    InputItemReceipt,
  },
  props: {
    mode: {
      type: String,
      default: 'create',
    },
    requestId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isPrintLoading: false,
      itemLoad: false,
      subItemLoad: false,
      expand: false,
      isLoadingSpNumber: false,
      menu: false,
      newReceiptNumber: '',
      dialog: false,
      isEditMode: false,
      tempOrigin: '',
      isDetail: this.mode === 'detail',
      snackbar: { show: false, text: '', color: '' },
      hasChanges: false,
      rules: {
        required: [v => !!v || 'Belum dipilih'],
        notZero: [
          v => !!v || 'Belum diisi',
          v => this.formatToNumber(v) > 0 || 'Jumlah Harus Lebih dari 0',
        ],
        downPayment: [
          v => !!v || 'Belum diisi',
          v =>
            this.formatToNumber(v) <= this.totalBill ||
            'Nilai melebihi total tagihan',
        ],
      },
      table: {
        headers: [
          {
            text: 'No',
            align: 'start',
            sortable: false,
            value: 'index',
          },
          { text: 'Nama Barang', sortable: false, value: 'name.name' },
          { text: 'Jumlah Pesanan', sortable: false, value: 'totalItem' },
          { text: 'Package', sortable: false, value: 'name.package' },
          { text: 'Harga', sortable: false, value: 'name.hna', align: 'end' },
          { text: 'Total', sortable: false, value: 'subTotal', align: 'end' },
          { text: '', sortable: false, value: 'action' },
        ],
        dataItem: [],
      },
      form: {
        id: '',
        total_price: 0,
        supplier: '',
        payment_method: '', // "cash" (cash), "tempo" (tempo), "consignment" (konsinyasi), "grant" (hibah)
        ppn: 11,
        shipping_cost: 0,
        stamp_cost: 0,
        down_payment: 0,
        isDpTypePercent: false,
        down_payment_type: '', // "percent" (persen), "nominal" (harga fix)
        item: [],
        status: '',
        orderDate: moment().format('DD MMMM YYYY HH:mm') + ' WIB',
        cancelledDate: '',
        orderStaff: '',
        createdBy: '',
      },
      formDetail: {
        goods: '',
        quantity: '',
        package: '',
      },
      selectSupplier: [],
      selectBarang: [],
      defaultSelectBarang: [],
      disabledList: [],
      selectpackage: [],
      getdrugs: [],
      getgoods: [],
      item: [],
      packageItem: [],
      searchGood: '',
      resource: {
        paymentMethod: [
          { text: 'Cash', value: 'cash' },
          { text: 'Tempo', value: 'tempo' },
          { text: 'Konsinyasi', value: 'consignment' },
          { text: 'Hibah', value: 'grant' },
        ],
      },
    };
  },
  computed: {
    title() {
      const title =
        this.isDetail && this.isDisabled
          ? 'Detail '
          : this.isDetail && !this.isEditMode
          ? 'Ubah '
          : '';

      return title;
    },
    isDisabled() {
      return this.isDetail && !this.isEditMode;
    },
    isCancelledDetail() {
      return this.form.status === 'cancelled' && this.isDetail;
    },
    activeUser() {
      return this.$store.getters.userLoggedIn;
    },
    isDataCreator() {
      return (
        this.activeUser.role[0] === 'kepala unit' ||
        this.form.createdBy === this.activeUser.id
      );
    },
    totalAllItemPrice() {
      // IF data received, dont recalculate total_price
      if (this.form.status == 'received') {
        return this.form.total_price;
      } else {
        return Math.round(
          this.form.item.reduce(
            (prev, next) =>
              prev +
              (next.package?.quantity
                ? this.calculatePrice(next.goods?.hna, next.package?.quantity)
                : next.price || 0) *
                next.quantity,
            0,
          ),
        );
      }
    },
    totalPpn() {
      return Math.round((this.totalAllItemPrice * this.form.ppn) / 100);
    },

    totalBill() {
      return Math.round(
        this.totalAllItemPrice +
          this.totalPpn +
          (this.form.stamp_cost ?? 0) +
          (this.form.shipping_cost ?? 0),
      );
    },

    outstandingBill() {
      if (this.form.isDpTypePercent) {
        return Math.round(this.totalBill * (1 - this.form.down_payment / 100));
      } else {
        return Math.round(this.totalBill - this.form.down_payment);
      }
    },
  },
  methods: {
    searchData: _.debounce(v => {
      // eslint-disable-next-line no-param-reassign
      v.getItem(true);
    }, 650),
    searchDataList: _.debounce((v, keyword, index) => {
      // eslint-disable-next-line no-param-reassign
      v.getGoodsInItemList(keyword, index);
    }, 650),
    closeForm() {
      this.dialog = false;
      this.getSupplyById(this.form.id);
    },
    formatToNumber(formattedText) {
      if (formattedText) {
        return parseInt(formattedText.replace(/\./g, ''), 10);
      }
    },
    getDataSupllier() {
      const title = this.title.trim();
      axios
        .get(
          Constant.apiUrl.concat(
            `/master/supplier?active=${title === '' ? 'true' : ''}`,
          ),
        )
        .then(response => {
          const getSupplier = response.data.data;
          this.selectSupplier = getSupplier.map(selectSupplier => {
            return {
              id: selectSupplier._id.toString(),
              name: selectSupplier.name,
              address: selectSupplier.detail[0].address,
            };
          });
        });
    },
    onCloseButtonClick() {
      if (this.hasChanges) {
        setTimeout(() => {
          return Swal.fire({
            title: `<div style="font-family: Roboto, Serif; color: #222222; font-weight: 700; font-size: 20px; line-height: 30px;"><p>Data Pemesanan belum tersimpan</p></div>`,
            iconHtml:
              '<span style="color: #F9A825" class="mdi mdi-alert-circle-outline"></span>',
            html: `<div style="font-family: Roboto; font-style: normal; font-weight: 400; font-size: 14px; color: #616161; line-height: 150%; text-transform: none !important;"><p>Silakan kembali dan simpan terlebih dahulu</div>`,
            showCancelButton: true,
            customClass: {
              confirmButton: 'button-error-blue',
              cancelButton: 'button-confirm',
            },
            confirmButtonText: 'Keluar',
            cancelButtonText: 'Kembali',
          }).then(result => {
            if (result.isConfirmed) {
              this.$emit('close-form');
            }
          });
        }, 300);
      } else {
        this.$emit('close-form');
      }
    },
    async getNewSpNumber() {
      this.isLoadingSpNumber = true;
      try {
        const response = await axios.get(
          Constant.apiUrl.concat('/supply/spnumber'),
        );
        this.newReceiptNumber = response.data.data;
      } catch (error) {
        Swal.fire('Gagal mendapatkan nomor SP', '', 'error');
      } finally {
        this.isLoadingSpNumber = false;
      }
    },
    getItem(isSearch) {
      this.itemLoad = true;
      const keyword = this.searchGood;

      axios
        .get(
          Constant.apiUrl.concat(
            `/master/drugs/goods/all?page=1&itemCount=40&search=${encodeURIComponent(
              keyword || '',
            )}`,
          ),
        )
        .then(async response => {
          const data = response.data.data;
          this.selectBarang = await this.disableList(
            data.map(v => {
              return {
                id: v?.id_drug ?? v?.id_good,
                id_drugs: v?.id_drug,
                id_goods: v?.id_good,
                name: v.display_name_nofornas,
                displayName: v.display_name_nofornas,
                hna: v.hna,
                category: v.category,
                package: v.packaging,
              };
            }),
          );
          if (!isSearch) {
            this.defaultSelectBarang = this.selectBarang;
          }
        })
        .catch(() => {
          this.selectBarang = [];
        })
        .finally(() => (this.itemLoad = false));
    },
    getPackage(isEdit = false, index) {
      if (isEdit) {
        this.form.item[index].package = '';
        this.form.item[index].packageItem = this.form.item[
          index
        ].goods?.package.map(v => {
          return {
            name: v.package,
            quantity: v.quantity,
          };
        }); // this.form.item[index].package = '';
        this.form.item[index].packageItem = this.form.item[
          index
        ].goods?.package.map(v => {
          return {
            name: v.package,
            quantity: v.quantity,
          };
        });
      } else {
        this.formDetail.package = '';
        this.packageItem = this.formDetail.goods?.package.map(v => {
          return {
            name: v.package,
            quantity: v.quantity,
          };
        });
      }
    },
    addNewList() {
      if (this.$refs.form.validate()) {
        const data = this.form.item.find(
          v => v.goods?.id == this.formDetail.goods.id,
        );
        if (data) {
          Swal.fire(
            'Barang sudah ditambahkan',
            'Silahkan hapus terlebih dahulu untuk menambahkan barang yang sama',
            'warning',
          );
        } else {
          this.form.item.push({
            goods: this.formDetail.goods,
            package: this.formDetail.package,
            quantity: this.formDetail.quantity,
            packageItem: this.packageItem,
            id: this.formDetail.goods?.id,
            listItemGoods: [{ ...this.formDetail?.goods }],
            creationDate: moment().format(),
          });

          this.form.item = this.form.item.sort((a, b) => {
            const dateA = a.creationDate
              ? new Date(a.creationDate).getTime()
              : -Infinity;
            const dateB = b.creationDate
              ? new Date(b.creationDate).getTime()
              : -Infinity;
            return dateB - dateA;
          });

          this.afterAdd();
          this.$refs.form.resetValidation();
        }
      }
    },

    removeFromList(index) {
      if (this.isEditMode) {
        this.$nextTick(() => {
          setTimeout(() => {
            Swal.fire({
              title: `<div style="font-family: Roboto, Serif; color: #222222; font-weight: 700; font-size: 20px; line-height: 30px;"><p>Apakah anda yakin untuk menghapus nama Barang?</p></div>`,
              iconHtml:
                '<span style="color: #F9A825" class="mdi mdi-help-circle-outline"></span>',
              showCancelButton: true,
              customClass: {
                confirmButton: 'button-error-blue',
                cancelButton: 'button-confirm',
              },
              confirmButtonText: 'Yakin',
              cancelButtonText: 'Batal',
            }).then(result => {
              if (result.isConfirmed) {
                this.form.item.splice(index, 1);
                this.hasChanges = true;
              } else {
                return;
              }
            });
          }, 300);
        });
      } else {
        this.form.item.splice(index, 1);
      }
    },

    afterAdd() {
      this.formDetail = {
        goods: '',
        quantity: '',
        package: '',
      };
      this.packageItem = [];
      this.hasChanges = true;
    },

    calculatePrice(hna = 0, itemsPerPackage = 0) {
      return Math.round(hna * itemsPerPackage);
    },

    switchDpType() {
      this.form.isDpTypePercent = !this.form.isDpTypePercent;
      this.$refs.formCost.resetValidation();
      if (!this.form.isDpTypePercent) {
        this.rules.downPayment = [
          v => !!v || 'Belum diisi',
          v =>
            this.formatToNumber(v) < this.totalBill ||
            'Nilai melebihi total tagihan',
        ];
      } else {
        this.rules.downPayment = [
          v => !!v || 'Belum diisi',
          v => this.formatToNumber(v) < 101 || 'Nilai melebihi 100%',
        ];
      }
    },
    formatCurrency(val) {
      return (
        'Rp ' + val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ',00'
      );
    },
    getSupplyById(id) {
      axios
        .get(Constant.apiUrl.concat('/supply/request/').concat(id))
        .then(response => {
          const getDataSupply = response.data.data;
          this.form.id = id;
          this.form.total_price = getDataSupply.total_price;
          this.form.supplier = {
            ...getDataSupply.id_supplier,
            id: getDataSupply.id_supplier._id,
          };
          this.form.payment_method = getDataSupply.payment_method;
          this.form.status = getDataSupply.status;
          this.form.ppn = getDataSupply.ppn;
          this.newReceiptNumber = getDataSupply.order_number;
          this.form.orderDate =
            moment(getDataSupply.order_date).format('DD MMMM YYYY HH:mm') +
            ' WIB';
          this.form.orderStaff = getDataSupply.timestamps.created_by.name;
          this.form.stamp_cost = getDataSupply.stamp_cost;
          this.form.shipping_cost = getDataSupply.shipping_cost;
          this.form.down_payment = getDataSupply.down_payment || 0;
          this.form.isDpTypePercent = getDataSupply.down_payment_type
            ? getDataSupply.down_payment_type === 'percent'
              ? true
              : false
            : true;
          this.form.createdBy = getDataSupply.timestamps.created_by.id;
          this.form.item = getDataSupply.item.map(item => {
            return {
              ...item,
              goods: {
                id: item.id_goods ?? item.id_drugs,
                id_goods: item.id_goods,
                hna: item.hna,
                displayName: item.name,
                category: item.category,
                name: item.name,
                id_drugs: item.id_drugs,
              },
              package: {
                name: item.package,
                quantity:
                  item.itemsPerPackage ||
                  item.packaging?.find(f => f?.isDefault)?.quantity,
              },
              packageItem: item.packaging.map(pack => {
                return {
                  name: pack.package,
                  quantity: pack.quantity,
                };
              }),
              listItemGoods: [
                {
                  id: item.id_goods ?? item.id_drugs,
                  id_goods: item?.id_goods ?? undefined,
                  hna: item.hna,
                  displayName: item.name,
                  category: item.category,
                  name: item.name,
                  id_drugs: item?.id_drugs ?? undefined,
                  package: item.packaging,
                  disabled: true,
                },
              ],
            };
          });

          this.tempOrigin = JSON.stringify(this.form);
        });
    },
    saveDataOrder() {
      if (
        !this.$refs.formSupplier.validate() ||
        !this.$refs.formCost.validate() ||
        !this.$refs.formTable.validate()
      ) {
        return;
      }
      const payload = {
        order_date: moment().format('DD-MM-YYYY'),
        total_price: this.totalAllItemPrice,
        id_supplier: this.form.supplier.id,
        payment_method: this.form.payment_method, // "cash" (cash), "tempo" (tempo), "consignment" (konsinyasi), "grant" (hibah)
        ppn: this.form.ppn,
        shipping_cost: this.form.shipping_cost,
        stamp_cost: this.form.stamp_cost,
        down_payment: this.form.down_payment,
        down_payment_type: this.form.isDpTypePercent ? 'percent' : 'nominal', // "percent" (persen), "nominal" (harga fix)
        item: this.form.item.map(item => {
          return {
            id_drugs: item.goods.id_drugs,
            id_goods: item.goods.id_goods,
            quantity: item.quantity,
            package: item.package.name,
            sub_total: Math.round(
              (item.package?.quantity
                ? this.calculatePrice(item.goods.hna, item.package.quantity)
                : item.price || 0) * item.quantity,
            ),
            name: item.goods.displayName,
            price: item.goods.hna,
            category: item.goods.category,
            itemsPerPackage: item.package.quantity,
          };
        }),
      };
      axios
        .post(Constant.apiUrl.concat('/supply/request'), payload)
        .then(response => {
          if (response.status === 200) {
            this.snackbar.show = true;
            this.snackbar.color = '#2B9C4D';
            this.snackbar.text = 'Pemesanan berhasil disimpan';
            this.isDetail = true;
            this.hasChanges = false;
            this.getSupplyById(response.data.data._id);
          }
        })
        .catch(error => {
          if (error.response) {
            const message = error.response.data.message;
            this.snackbar.show = true;
            this.snackbar.color = '#d32f2f';
            this.snackbar.text = message;
          } else if (error.request) {
            this.snackbar.show = true;
            this.snackbar.color = '#d32f2f';
            this.snackbar.text = 'Tidak dapat menyambung ke server';
          }
        });
    },
    confirmOrSaveChanges(isConfirm = false) {
      if (isConfirm) {
        this.dialog = true;
      } else {
        this.updateData();
      }
    },
    updateData() {
      if (
        !this.$refs.formSupplier.validate() ||
        !this.$refs.formCost.validate() ||
        !this.$refs.formTable.validate()
      ) {
        return;
      }
      const payload = {
        total_price: this.totalAllItemPrice, // "cash" (cash), "tempo" (tempo), "consignment" (konsinyasi), "grant" (hibah)
        ppn: this.form.ppn,
        shipping_cost: this.form.shipping_cost ?? 0,
        stamp_cost: this.form.stamp_cost ?? 0,
        down_payment: this.form.down_payment,
        id_supplier: this.form.supplier.id,
        payment_method: this.form.payment_method,
        down_payment_type: this.form.isDpTypePercent ? 'percent' : 'nominal', // "percent" (persen), "nominal" (harga fix)
        item: this.form.item.map(item => {
          return {
            id_drugs: item.goods.id_drugs ?? undefined,
            id_goods: item.goods.id_goods ?? undefined,
            quantity: item.quantity,
            package: item.package.name,
            sub_total: Math.round(
              (item.package?.quantity
                ? this.calculatePrice(item.goods.hna, item.package.quantity)
                : item.price || 0) * item.quantity,
            ),
            name: item.goods.displayName,
            price: item.goods.hna,
            category: item.goods.category,
            itemsPerPackage: item.package.quantity,
          };
        }),
      };
      axios
        .put(
          Constant.apiUrl.concat(
            `/supply/request/${this.requestId || this.form.id}`,
          ),
          payload,
        )
        .then(response => {
          if (response.status === 200) {
            this.snackbar.show = true;
            this.snackbar.color = '#2B9C4D';
            this.snackbar.text = 'Perubahan berhasil disimpan';
            this.isDetail = true;
            this.getSupplyById(response.data.data._id);
            this.isEditMode = false;
            this.hasChanges = false;
          }
        })
        .catch(error => {
          if (error.response) {
            const message = error.response.data.message;
            this.snackbar.show = true;
            this.snackbar.color = '#d32f2f';
            this.snackbar.text = message;
          } else if (error.request) {
            this.snackbar.show = true;
            this.snackbar.color = '#d32f2f';
            this.snackbar.text = 'Tidak dapat menyambung ke server';
          }
        });
    },

    onClickCancelOrder() {
      this.$nextTick(() => {
        setTimeout(() => {
          Swal.fire({
            title: `<div style="font-family: Roboto, Serif; color: #222222; font-weight: 700; font-size: 20px; line-height: 30px;"><p>Apakah Anda yakin untuk membatalkan pemesanan?</p></div>`,
            iconHtml:
              '<span style="color: #F9A825" class="mdi mdi-alert-circle-outline"></span>',
            html: `<div style="font-family: Roboto; font-style: normal; font-weight: 400; font-size: 14px; color: #616161; line-height: 150%; text-transform: none !important;"><p>Data pemesanan <b>${this.newReceiptNumber}</b> akan dibatalkan dan tidak bisa diubah kembali</div>`,
            showCancelButton: true,
            customClass: {
              confirmButton: 'button-error-blue',
              cancelButton: 'button-confirm',
            },
            confirmButtonText: 'Yakin',
            cancelButtonText: 'Batal',
          }).then(result => {
            if (result.isConfirmed) {
              this.cancelOrder(this.requestId || this.form.id);
            } else {
              return;
            }
          });
        }, 300);
      });
    },

    cancelOrder(id) {
      axios
        .put(Constant.apiUrl.concat(`/supply/request/cancel/${id}`), {
          status: 'cancelled',
        })
        .then(() => {
          this.getSupplyById(id);
          this.$emit('close-form', true, {
            show: true,
            color: '#2B9C4D',
            text: 'Pemesanan berhasil dibatalkan',
          });
        })
        .catch(error => {
          if (error.response) {
            const message =
              error.response.data.pesan ?? 'Internal server error';
            this.snackbar.show = true;
            this.snackbar.color = '#d32f2f';
            this.snackbar.text = message;
          } else if (error.request) {
            this.snackbar.show = true;
            this.snackbar.color = '#d32f2f';
            this.snackbar.text = 'Tidak dapat menyambung ke server';
          }
        });
    },
    printSp() {
      const id = this.requestId || this.form.id;
      this.$emit('print-sp', { id: id });
    },
    onSearchGoodsInItemList(input, index) {
      this.searchDataList(this, input, index);
    },
    getGoodsInItemList(keyword, index) {
      this.subItemLoad = true;
      axios
        .get(
          Constant.apiUrl.concat(
            `/master/drugs/goods/all?page=1&itemCount=40&search=${encodeURIComponent(
              keyword || '',
            )}`,
          ),
        )
        .then(async response => {
          const data = response.data.data;
          this.form.item[index].listItemGoods = await this.disableList(
            data.map(v => {
              return {
                id: v?.id_drug ?? v?.id_good,
                id_drugs: v?.id_drug ?? undefined,
                id_goods: v?.id_good ?? undefined,
                name: v.display_name_nofornas,
                displayName: v.display_name_nofornas,
                hna: v.hna,
                category: v.category,
                package: v.packaging,
              };
            }),
          );
          this.selectBarang = await this.disableList(this.selectBarang);
          this.subItemLoad = false;
        })
        .catch(() => {
          this.form.item[index].listItemGoods = [];
          this.subItemLoad = false;
        })
        .finally(() => (this.subItemLoad = false));
    },
    async disableList(list) {
      if (list.length > 0) {
        const res = list
          .map(item => {
            const find = this.form.item.find(f => f.goods?.id === item.id);
            if (find) {
              if (find.goods !== null) {
                return { ...item, disabled: true };
              } else {
                return { ...item, disabled: false };
              }
            } else {
              return { ...item, disabled: false };
            }
          })
          .sort((a, b) => {
            if (a.disabled === b.disabled) return 0; // no change if both are disabled or both are enabled
            return a.disabled ? 1 : -1; // move disabled items to the bottom
          });
        return res;
      }
    },

    async promptChanges() {
      setTimeout(() => {
        return Swal.fire({
          title: `<div style="font-family: Roboto, Serif; color: #222222; font-weight: 700; font-size: 20px; line-height: 30px;"><p>Data Pemesanan belum tersimpan</p></div>`,
          iconHtml:
            '<span style="color: #F9A825" class="mdi mdi-alert-circle-outline"></span>',
          html: `<div style="font-family: Roboto; font-style: normal; font-weight: 400; font-size: 14px; color: #616161; line-height: 150%; text-transform: none !important;"><p>Silakan kembali dan simpan terlebih dahulu</div>`,
          showCancelButton: true,
          customClass: {
            confirmButton: 'button-error-blue',
            cancelButton: 'button-confirm',
          },
          confirmButtonText: 'Keluar',
          cancelButtonText: 'Kembali',
        }).then(result => {
          return result;
        });
      }, 300);
    },
    onCancelChanges() {
      if (this.isEditMode && this.hasChanges) {
        setTimeout(() => {
          return Swal.fire({
            title: `<div style="font-family: Roboto, Serif; color: #222222; font-weight: 700; font-size: 20px; line-height: 30px;"><p>Data Pemesanan belum tersimpan</p></div>`,
            iconHtml:
              '<span style="color: #F9A825" class="mdi mdi-alert-circle-outline"></span>',
            html: `<div style="font-family: Roboto; font-style: normal; font-weight: 400; font-size: 14px; color: #616161; line-height: 150%; text-transform: none !important;"><p>Silakan kembali dan simpan terlebih dahulu</div>`,
            showCancelButton: true,
            customClass: {
              confirmButton: 'button-error-blue',
              cancelButton: 'button-confirm',
            },
            confirmButtonText: 'Keluar',
            cancelButtonText: 'Kembali',
          }).then(result => {
            if (result.isConfirmed) {
              this.form = JSON.parse(this.tempOrigin);
              this.hasChanges = false;
              this.isEditMode = !this.isEditMode;
            }
          });
        }, 300);
      } else {
        this.isEditMode = !this.isEditMode;
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.getDataSupllier();
      this.getNewSpNumber();
      this.getItem();
      if (this.isDetail && this.requestId !== '') {
        this.getSupplyById(this.requestId);
      } else {
        this.tempOrigin = JSON.stringify(this.form);
      }
    });
  },
  watch: {
    searchGood() {
      this.searchData(this);
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-disable {
  background-color: #9e9e9e !important;
  color: white;
}
.input {
  max-width: 50%;
}

.total-all {
  width: 50%;
}

.underline {
  border-bottom: 1px grey solid;
}

.required::after {
  content: '*';
  color: #eb4747;
}

::v-deep .v-list-item .v-list-item__content {
  line-height: 1.1;
  flex: 1 0 100%;
  text-align: start;
}
.full-text-autocomplete .v-input__slot {
  overflow: visible !important;
}

.full-text-autocomplete input {
  text-overflow: unset !important;
  white-space: normal !important;
  overflow: visible !important;
}
.v-input.v-input--is-disabled:not(.label) ::v-deep {
  overflow: visible !important;
  input {
    height: 0px;
    overflow: visible !important;
    // width: auto;
  }
  .v-input__slot {
    background: transparent !important;
    background-color: transparent !important;
    height: auto;
    // width: auto;
  }
  .v-text-field__details::before {
    display: none;
  }
  fieldset {
    border: none !important;
    box-shadow: none !important;
    // width: auto;
  }
  margin-left: -12px;
  .v-input__icon {
    display: none;
  }
}

.card {
  ::v-deep .v-card__text {
    justify-content: start !important;
    align-items: start !important;
    text-align: left !important;
    max-height: 80vh;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 5px;
      border-radius: 5px;
      background-color: #d4d4d4;
    }
    &::-webkit-scrollbar-thumb {
      width: 5px;
      border-radius: 5px;
      background-color: rgb(123, 121, 121);
    }
  }
}

::v-deep .v-btn .v-btn__content {
  text-transform: none !important;
}

.sub-header {
  font-weight: 600;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 0%;
  color: #404040;
}

.detail-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
  .input-container {
    display: flex;
    align-items: center;
    span {
      width: 200px;
      font-family: Roboto;
      font-weight: 500;
      font-size: 14px;
      line-height: 120%;
      letter-spacing: 0.5%;
      color: #404040;
    }
  }
}

.form-container.active {
  min-height: 100px;
  background: #fafafa;
  border: 1px solid #e0e0e0;
  margin-top: 25px;
  border-radius: 8px;
  padding: 20px;
}

.form-input {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  margin-top: 10px;
  grid-column-gap: 20px;
  div label span {
    color: #d32f2f;
  }
}

.h-separator {
  width: 100%;
  border-bottom: 1px solid #e0e0e0;
  margin-top: 20px;
  margin-bottom: 20px;
}

::v-deep {
  .v-data-table .v-data-table-header {
    background-color: #f5f5f5;

    span {
      color: #9e9e9e;
    }
  }
}

.cost-details {
  min-width: 450px;
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  .item-detail {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-column-gap: 0px;
    align-items: center;
    div {
      text-align: right;
      text-wrap: nowrap;
    }
  }
  span {
    color: #1976d2;
    font-family: Roboto;
    font-weight: 500;
    font-size: 14px;
    line-height: 120%;
    letter-spacing: 0.5%;
  }
}

.currency.v-input ::v-deep input {
  text-align: end !important;
}

.badge {
  padding: 8px;
  border-radius: 4px;
  text-align: center;
  width: fit-content;
  text-wrap: nowrap;
  &.pending {
    background: #fffbea;
    color: #e26c00;
  }

  &.received {
    background: #e7f8ec;
    color: #2b9c4d;
  }

  &.cancelled {
    background: #ffebee;
    color: #d32f2f;
  }
}

.detail-panel {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  margin-top: 25px;
  gap: 20px;
  grid-column-gap: 40px;
  &.cancelled {
    grid-template-columns: repeat(3, 1fr);
  }
}

.sticky-table ::v-deep thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: #f5f5f5;
}
.sticky-table ::v-deep .v-data-table__wrapper {
  max-height: 350px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 5px;
    border-radius: 5px;
    background-color: #d4d4d4;
  }
  &::-webkit-scrollbar-thumb {
    width: 5px;
    border-radius: 5px;
    background-color: rgb(123, 121, 121);
  }
}
</style>
